import $ from 'jquery';
import { getState, modifyState } from '~src/state';
import { trackEvent } from '~src/tracking';
import { notify } from '~src/notifications';
import { isFeatureEnabled, FEATURES } from '~src/features';
import { DEFAULT_SETTINGS } from './constants';
import { saveSettingsToLocalStorage } from './localStorage';
import { applySettings } from './applySettings';

export async function saveSettings() {
  const spellCheckToggle = document.getElementById('spellCheckerToggle');
  const alignmentLinesToggle = document.getElementById('alignmentLinesToggle');
  const canvasAlignmentToggle = document.getElementById(
    'canvasAlignmentToggle'
  );
  const objectAlignmentToggle = document.getElementById(
    'objectAlignmentToggle'
  );
  const distanceMeasurementsToggle = document.getElementById(
    'distanceMeasurementsToggle'
  );
  const snappingToggle = document.getElementById('snappingToggle');

  // Check if spellcheck feature is enabled
  const spellCheckFeatureEnabled = await isFeatureEnabled(FEATURES.SPELLCHECK);

  const newSettings = {
    spellCheckEnabled:
      spellCheckFeatureEnabled && spellCheckToggle
        ? spellCheckToggle.checked
        : DEFAULT_SETTINGS.spellCheckEnabled,
    alignmentLinesEnabled: alignmentLinesToggle
      ? alignmentLinesToggle.checked
      : DEFAULT_SETTINGS.alignmentLinesEnabled,
    canvasAlignmentLinesEnabled: canvasAlignmentToggle
      ? canvasAlignmentToggle.checked
      : DEFAULT_SETTINGS.canvasAlignmentLinesEnabled,
    objectAlignmentLinesEnabled: objectAlignmentToggle
      ? objectAlignmentToggle.checked
      : DEFAULT_SETTINGS.objectAlignmentLinesEnabled,
    showDistanceMeasurements: distanceMeasurementsToggle
      ? distanceMeasurementsToggle.checked
      : DEFAULT_SETTINGS.showDistanceMeasurements,
    snappingEnabled: snappingToggle
      ? snappingToggle.checked
      : DEFAULT_SETTINGS.snappingEnabled,
  };

  const oldSettings = getState('settings') || DEFAULT_SETTINGS;

  // Save to state and localStorage
  modifyState('settings', newSettings);
  saveSettingsToLocalStorage(newSettings);

  // Apply settings
  applySettings();

  // Set saved flag to prevent tracking close as cancelled
  $('#modalEditorSettings').data('saved', true);

  // Close modal
  $('#modalEditorSettings').modal('hide');

  // Show success notification
  notify({
    title: 'Impostazioni salvate',
    text: 'Le impostazioni sono state salvate con successo.',
    type: 'success',
    delay: 2000,
  });

  // Track successful save
  trackEvent('Settings Saved', {
    spell_check_enabled: newSettings.spellCheckEnabled,
    alignment_lines_enabled: newSettings.alignmentLinesEnabled,
    canvas_alignment_lines_enabled: newSettings.canvasAlignmentLinesEnabled,
    object_alignment_lines_enabled: newSettings.objectAlignmentLinesEnabled,
    show_distance_measurements: newSettings.showDistanceMeasurements,
    snapping_enabled: newSettings.snappingEnabled,
    changes_made: {
      spell_check:
        oldSettings.spellCheckEnabled !== newSettings.spellCheckEnabled,
      alignment_lines:
        oldSettings.alignmentLinesEnabled !== newSettings.alignmentLinesEnabled,
      canvas_alignment:
        oldSettings.canvasAlignmentLinesEnabled !==
        newSettings.canvasAlignmentLinesEnabled,
      object_alignment:
        oldSettings.objectAlignmentLinesEnabled !==
        newSettings.objectAlignmentLinesEnabled,
      distance_measurements:
        oldSettings.showDistanceMeasurements !==
        newSettings.showDistanceMeasurements,
      snapping: oldSettings.snappingEnabled !== newSettings.snappingEnabled,
    },
  });
}
